import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const Wrapper = styled(Flex)`
    position: relative;
    box-sizing: border-box;
    background-color: ${colorsPalettes.blue[50]};
    border-radius: 8px;
    padding: 72px;
    justify-content: center;
    align-items: stretch;
    gap: 20px;
    height: 100%;
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 16px;
    right: 16px;
`;
